<add-to-favorite
    [variants]="variants"
    [model]="model"
    [configuration]="configuration"
    [modelSize]="modelSize"
    [manualconfigGroups]="allManualConfigGroups"
    [templeInclination]="templeInclination"
    [favoriteUuid]="favoriteUuid"
    [isInCollection]="isInCollection"
    (showMyCollectionsOverlay)="showMyCollections()" 
    (applyFavoriteChange)="applyFavoriteChange(favoriteUuid)"
></add-to-favorite>